var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _g2, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoSquare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 48,
    viewBox: "0 0 46 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_70",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 22,
    width: 4,
    height: 4
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 22.236H3.08939V25.3102H0V22.236Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_70)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.0894 23.7736C3.0894 24.6224 2.39729 25.3102 1.54462 25.3102C0.691408 25.3102 -0.000152588 24.6224 -0.000152588 23.7736C-0.000152588 22.9244 0.691408 22.236 1.54462 22.236C2.39729 22.236 3.0894 22.9244 3.0894 23.7736Z",
    fill: "black"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.31144 19.6891C3.31144 20.4113 2.72345 20.9966 1.99846 20.9966C1.27402 20.9966 0.685486 20.4113 0.685486 19.6891C0.685486 18.968 1.27402 18.3827 1.99846 18.3827C2.72345 18.3827 3.31144 18.968 3.31144 19.6891Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.26427 16.3123C4.26427 16.9259 3.76451 17.4228 3.14802 17.4228C2.53208 17.4228 2.03232 16.9259 2.03232 16.3123C2.03232 15.6986 2.53208 15.2012 3.14802 15.2012C3.76451 15.2012 4.26427 15.6986 4.26427 16.3123Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.58689 13.6143C5.58689 14.1357 5.16165 14.5579 4.63833 14.5579C4.11445 14.5579 3.69031 14.1357 3.69031 13.6143C3.69031 13.0928 4.11445 12.6706 4.63833 12.6706C5.16165 12.6706 5.58689 13.0928 5.58689 13.6143Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.15271 11.4652C7.15271 11.9087 6.79158 12.2676 6.34662 12.2676C5.90165 12.2676 5.54108 11.9087 5.54108 11.4652C5.54108 11.0223 5.90165 10.6629 6.34662 10.6629C6.79158 10.6629 7.15271 11.0223 7.15271 11.4652Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.70331 9.86509C8.70331 10.242 8.39644 10.5475 8.01833 10.5475C7.63967 10.5475 7.33279 10.242 7.33279 9.86509C7.33279 9.48927 7.63967 9.18327 8.01833 9.18327C8.39644 9.18327 8.70331 9.48927 8.70331 9.86509Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1675 8.69804C10.1675 9.01768 9.90662 9.27732 9.58495 9.27732C9.26274 9.27732 9.00244 9.01768 9.00244 8.69804C9.00244 8.37786 9.26274 8.11823 9.58495 8.11823C9.90662 8.11823 10.1675 8.37786 10.1675 8.69804Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5088 7.80715C11.5088 8.07933 11.2874 8.29969 11.0139 8.29969C10.7405 8.29969 10.5186 8.07933 10.5186 7.80715C10.5186 7.53497 10.7405 7.31406 11.0139 7.31406C11.2874 7.31406 11.5088 7.53497 11.5088 7.80715Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8052 7.12396C12.8052 7.35523 12.6166 7.54341 12.3843 7.54341C12.1519 7.54341 11.964 7.35523 11.964 7.12396C11.964 6.89268 12.1519 6.70505 12.3843 6.70505C12.6166 6.70505 12.8052 6.89268 12.8052 7.12396Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9201 6.65068C13.9201 6.84759 13.7596 7.00631 13.5623 7.00631C13.3645 7.00631 13.2045 6.84759 13.2045 6.65068C13.2045 6.45377 13.3645 6.29449 13.5623 6.29449C13.7596 6.29449 13.9201 6.45377 13.9201 6.65068Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9313 6.31381C14.9313 6.48126 14.7954 6.61654 14.6272 6.61654C14.4595 6.61654 14.3236 6.48126 14.3236 6.31381C14.3236 6.14745 14.4595 6.01163 14.6272 6.01163C14.7954 6.01163 14.9313 6.14745 14.9313 6.31381Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.31144 27.8571C3.31144 27.1355 2.72345 26.5502 1.99846 26.5502C1.27402 26.5502 0.685486 27.1355 0.685486 27.8571C0.685486 28.5788 1.27402 29.164 1.99846 29.164C2.72345 29.164 3.31144 28.5788 3.31144 27.8571Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.26427 31.2337C4.26427 30.6212 3.76451 30.1237 3.14802 30.1237C2.53208 30.1237 2.03232 30.6212 2.03232 31.2337C2.03232 31.8484 2.53208 32.3448 3.14802 32.3448C3.76451 32.3448 4.26427 31.8484 4.26427 31.2337Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.58689 33.9333C5.58689 33.4102 5.16165 32.9885 4.63833 32.9885C4.11445 32.9885 3.69031 33.4102 3.69031 33.9333C3.69031 34.4531 4.11445 34.8764 4.63833 34.8764C5.16165 34.8764 5.58689 34.4531 5.58689 33.9333Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.15271 36.0821C7.15271 35.6392 6.79158 35.2786 6.34662 35.2786C5.90165 35.2786 5.54108 35.6392 5.54108 36.0821C5.54108 36.525 5.90165 36.8845 6.34662 36.8845C6.79158 36.8845 7.15271 36.525 7.15271 36.0821Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.70331 37.6811C8.70331 37.3048 8.39644 36.9993 8.01833 36.9993C7.63967 36.9993 7.33279 37.3048 7.33279 37.6811C7.33279 38.0581 7.63967 38.363 8.01833 38.363C8.39644 38.363 8.70331 38.0581 8.70331 37.6811Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1675 38.8487C10.1675 38.5291 9.90662 38.27 9.58495 38.27C9.26274 38.27 9.00244 38.5291 9.00244 38.8487C9.00244 39.1695 9.26274 39.4291 9.58495 39.4291C9.90662 39.4291 10.1675 39.1695 10.1675 38.8487Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5088 39.7394C11.5088 39.4677 11.2874 39.2474 11.0139 39.2474C10.7405 39.2474 10.5186 39.4677 10.5186 39.7394C10.5186 40.0121 10.7405 40.2324 11.0139 40.2324C11.2874 40.2324 11.5088 40.0121 11.5088 39.7394Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8052 40.4223C12.8052 40.191 12.6166 40.0045 12.3843 40.0045C12.1519 40.0045 11.964 40.191 11.964 40.4223C11.964 40.6541 12.1519 40.8423 12.3843 40.8423C12.6166 40.8423 12.8052 40.6541 12.8052 40.4223Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9201 40.8963C13.9201 40.7005 13.7596 40.5407 13.5623 40.5407C13.3645 40.5407 13.2045 40.7005 13.2045 40.8963C13.2045 41.0927 13.3645 41.2514 13.5623 41.2514C13.7596 41.2514 13.9201 41.0927 13.9201 40.8963Z",
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9313 41.233C14.9313 41.0655 14.7954 40.9297 14.6272 40.9297C14.4595 40.9297 14.3236 41.0655 14.3236 41.233C14.3236 41.4004 14.4595 41.5357 14.6272 41.5357C14.7954 41.5357 14.9313 41.4004 14.9313 41.233Z",
    fill: "black"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.1079 23.7736C41.1079 24.9098 42.0335 25.8311 43.1755 25.8311C44.3169 25.8311 45.2425 24.9098 45.2425 23.7736C45.2425 22.6375 44.3169 21.7162 43.1755 21.7162C42.0335 21.7162 41.1079 22.6375 41.1079 23.7736Z",
    fill: "black"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.8101 18.3076C40.8101 19.2736 41.5975 20.0569 42.568 20.0569C43.5374 20.0569 44.3238 19.2736 44.3238 18.3076C44.3238 17.3416 43.5374 16.5584 42.568 16.5584C41.5975 16.5584 40.8101 17.3416 40.8101 18.3076Z",
    fill: "black"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.5349 13.7869C39.5349 14.6078 40.2034 15.2738 41.0292 15.2738C41.8534 15.2738 42.5225 14.6078 42.5225 13.7869C42.5225 12.9654 41.8534 12.2999 41.0292 12.2999C40.2034 12.2999 39.5349 12.9654 39.5349 13.7869Z",
    fill: "black"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.7648 10.1762C37.7648 10.8743 38.3336 11.44 39.0345 11.44C39.7348 11.44 40.3042 10.8743 40.3042 10.1762C40.3042 9.47798 39.7348 8.91289 39.0345 8.91289C38.3336 8.91289 37.7648 9.47798 37.7648 10.1762Z",
    fill: "black"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.6684 7.29895C35.6684 7.89295 36.1517 8.37349 36.7474 8.37349C37.3436 8.37349 37.8269 7.89295 37.8269 7.29895C37.8269 6.70659 37.3436 6.22549 36.7474 6.22549C36.1517 6.22549 35.6684 6.70659 35.6684 7.29895Z",
    fill: "black"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.5937 5.1587C33.5937 5.66324 34.0046 6.07124 34.511 6.07124C35.0179 6.07124 35.4283 5.66324 35.4283 5.1587C35.4283 4.65415 35.0179 4.24561 34.511 4.24561C34.0046 4.24561 33.5937 4.65415 33.5937 5.1587Z",
    fill: "black"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.6337 3.5958C31.6337 4.02398 31.9838 4.37143 32.414 4.37143C32.8442 4.37143 33.1932 4.02398 33.1932 3.5958C33.1932 3.16707 32.8442 2.82016 32.414 2.82016C31.9838 2.82016 31.6337 3.16707 31.6337 3.5958Z",
    fill: "black"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.8383 2.40317C29.8383 2.76808 30.1353 3.06317 30.5014 3.06317C30.8669 3.06317 31.1644 2.76808 31.1644 2.40317C31.1644 2.03935 30.8669 1.74426 30.5014 1.74426C30.1353 1.74426 29.8383 2.03935 29.8383 2.40317Z",
    fill: "black"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.1033 1.48888C28.1033 1.7987 28.3554 2.05015 28.6661 2.05015C28.9779 2.05015 29.23 1.7987 29.23 1.48888C29.23 1.1796 28.9779 0.928696 28.6661 0.928696C28.3554 0.928696 28.1033 1.1796 28.1033 1.48888Z",
    fill: "black"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.6122 0.855767C26.6122 1.11868 26.8264 1.3314 27.0911 1.3314C27.3552 1.3314 27.5695 1.11868 27.5695 0.855767C27.5695 0.592312 27.3552 0.378494 27.0911 0.378494C26.8264 0.378494 26.6122 0.592312 26.6122 0.855767Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1_70",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 0,
    width: 2,
    height: 1
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2574 0H26.0712V0.810709H25.2574V0Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1_70)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.2574 0.404891C25.2574 0.629073 25.4399 0.810709 25.6646 0.810709C25.8893 0.810709 26.0712 0.629073 26.0712 0.404891C26.0712 0.1818 25.8893 -0.00038147 25.6646 -0.00038147C25.4399 -0.00038147 25.2574 0.1818 25.2574 0.404891Z",
    fill: "black"
  }))), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.8101 29.2394C40.8101 28.2739 41.5975 27.4912 42.568 27.4912C43.5374 27.4912 44.3238 28.2739 44.3238 29.2394C44.3238 30.2048 43.5374 30.9886 42.568 30.9886C41.5975 30.9886 40.8101 30.2048 40.8101 29.2394Z",
    fill: "black"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.5349 33.7596C39.5349 32.9392 40.2034 32.2732 41.0292 32.2732C41.8534 32.2732 42.5225 32.9392 42.5225 33.7596C42.5225 34.5811 41.8534 35.246 41.0292 35.246C40.2034 35.246 39.5349 34.5811 39.5349 33.7596Z",
    fill: "black"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.7648 37.3711C37.7648 36.6735 38.3336 36.1073 39.0345 36.1073C39.7348 36.1073 40.3042 36.6735 40.3042 37.3711C40.3042 38.0682 39.7348 38.6333 39.0345 38.6333C38.3336 38.6333 37.7648 38.0682 37.7648 37.3711Z",
    fill: "black"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.6684 40.2481C35.6684 39.6541 36.1517 39.1735 36.7474 39.1735C37.3436 39.1735 37.8269 39.6541 37.8269 40.2481C37.8269 40.8399 37.3436 41.3215 36.7474 41.3215C36.1517 41.3215 35.6684 40.8399 35.6684 40.2481Z",
    fill: "black"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.5937 42.3889C33.5937 41.8844 34.0046 41.4753 34.511 41.4753C35.0179 41.4753 35.4283 41.8844 35.4283 42.3889C35.4283 42.8929 35.0179 43.3009 34.511 43.3009C34.0046 43.3009 33.5937 42.8929 33.5937 42.3889Z",
    fill: "black"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.6337 43.9517C31.6337 43.5225 31.9838 43.175 32.414 43.175C32.8442 43.175 33.1932 43.5225 33.1932 43.9517C33.1932 44.3794 32.8442 44.7263 32.414 44.7263C31.9838 44.7263 31.6337 44.3794 31.6337 43.9517Z",
    fill: "black"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.8383 45.1433C29.8383 44.7784 30.1353 44.4839 30.5014 44.4839C30.8669 44.4839 31.1644 44.7784 31.1644 45.1433C31.1644 45.5083 30.8669 45.8022 30.5014 45.8022C30.1353 45.8022 29.8383 45.5083 29.8383 45.1433Z",
    fill: "black"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.1033 46.0574C28.1033 45.7481 28.3554 45.4966 28.6661 45.4966C28.9779 45.4966 29.23 45.7481 29.23 46.0574C29.23 46.3677 28.9779 46.6181 28.6661 46.6181C28.3554 46.6181 28.1033 46.3677 28.1033 46.0574Z",
    fill: "black"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.6122 46.6907C26.6122 46.4284 26.8264 46.2146 27.0911 46.2146C27.3552 46.2146 27.5695 46.4284 27.5695 46.6907C27.5695 46.9542 27.3552 47.1675 27.0911 47.1675C26.8264 47.1675 26.6122 46.9542 26.6122 46.6907Z",
    fill: "black"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.2574 47.1413C25.2574 46.9177 25.4399 46.7361 25.6646 46.7361C25.8893 46.7361 26.0712 46.9177 26.0712 47.1413C26.0712 47.365 25.8893 47.5472 25.6646 47.5472C25.4399 47.5472 25.2574 47.365 25.2574 47.1413Z",
    fill: "black"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3503 9.97456H22.3299V31.2146H32.8041V36.1951H16.3503V9.97456Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSquare);
export default __webpack_public_path__ + "static/media/logo_square.77fbf10672643037d7e58c05dae061bd.svg";
export { ForwardRef as ReactComponent };